import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';
import { PixiPlugin } from 'gsap/PixiPlugin';
import { Spine } from '../components/spine';
import { matricesByGameId } from '../../constants/enumsByGames';
import { gameConfigurationStore } from '../store/gameConfigurationStore';

class GameResourcesService {
  boardsSpine = [];

  allLinesSpine = [];

  allWinLinesBone = [];

  winCoinSpine = null;

  wildFireScene = null;


  winAmountTexture = null;

  setupPixiPlugins() {
    gsap.registerPlugin(PixiPlugin);
    PixiPlugin.registerPIXI(PIXI);
  }

  setWinAmountTexture(texture) {
    this.winAmountTexture = texture;
  }

  setBoardsSpine(boards) {
    this.boardsSpine = boards;
  }

  setWildFireScene(spine) {
    this.wildFireScene = spine;
  }

  setWinCoinSpine(spine) {
    this.winCoinSpine = spine;
  }

  setupAllLine(parentContainer) {
    const { gameId } = gameConfigurationStore;
    const { WinningLinesCoordinate } = matricesByGameId[gameId];
    [...WinningLinesCoordinate].forEach(() => {
      const winLine = new Spine({ key: 'winLine' });
      winLine.visible = false;
      this.allLinesSpine.push(winLine);
      parentContainer.addChild(winLine);
    });
    this.allWinLinesBone = this.allLinesSpine.map((el) =>
      el.skeleton.bones
        .filter((bone) => {
          return bone.data.name.includes('bone');
        })
        .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0))
    );
  }

  resetBoardSpine() {
    this.boardsSpine.forEach((board) => {
      board.stop();
    });
  }

  resetAllLineSpine() {
    this.allLinesSpine.forEach((line) => {
      line.stop();
    });
  }
}

export const gameResourcesService = new GameResourcesService();
